import { render, staticRenderFns } from "./DrnTemplatesList.vue?vue&type=template&id=46336958&"
import script from "./DrnTemplatesList.js?vue&type=script&lang=js&"
export * from "./DrnTemplatesList.js?vue&type=script&lang=js&"
import style0 from "./DrnTemplatesList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports